import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, branch, renderNothing, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import { loadOfferInfoRequest } from '../../actions/campaignOfferInfo';
import { getServicePropertyBySubscriptionReference, checkSubscriptionReference } from '../../helpers/getServiceProperty';
import PaymentPage from '../PaymentPage/PaymentPage';

function CustomCampaignUrl() {
  return <PaymentPage />;
}

const getSubscriptionData = (subscriptionReference, preLoadedStateServices) => {
  const price = getServicePropertyBySubscriptionReference(subscriptionReference, 'id');
  const subscriptionData = preLoadedStateServices.find(service => service.id === price);

  return subscriptionData;
};

function redirectToRootUrl() {
  window.location.href = '/subscriptions';
}

export default compose(
  connect(({ subscriptions: { selected }, userInfo }) => ({
    selected,
    authenticated: Boolean(userInfo.data),
  }), {
    loadOfferInfoRequest,
  }),
  lifecycle({
    componentDidMount() {
      const {
        loadOfferInfoRequest,
      } = this.props;

      const { subscriptionReference, offerReference, voucherCode } = this.props.match.params;
      const isSubscriptionFound = checkSubscriptionReference(subscriptionReference);

      if (!isSubscriptionFound) {
        console.error('Subscription reference not found'); // eslint-disable-line
        redirectToRootUrl();
        return;
      }

      const preLoadedStateServices = global.__PRELOADED_STATE__.services;
      const getSubscriptionSelectedData = getSubscriptionData(subscriptionReference, preLoadedStateServices);

      const payload = {
        subscriptionReference,
        offerReference,
        voucherCode,
        getSubscriptionSelectedData,
      };

      loadOfferInfoRequest(payload);
    },
  }),
  branch(
    props => !props.selected,
    renderNothing,
  ),
  setPropTypes({
    loadOfferInfoRequest: PropTypes.func.isRequired,
  }),
)(CustomCampaignUrl);
